import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { SxProps, Theme } from '@mui/system';

const HeroLayoutRoot = styled('section')(({ theme }) => ({
  color: theme.palette.common.white,
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
  // Mobile: show more height
  height: '50vh',
  minHeight: 400,
  [theme.breakpoints.up('sm')]: {
    height: '65vh',
    minHeight: 350,
    maxHeight: 1200,
  },
}));

// NEW: Styled image background to replace video
const ImageBackground = styled('img')({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  zIndex: -2,
});

interface HeroLayoutProps {
  sxBackground?: SxProps<Theme>;
  alignLeft?: boolean;
}

export default function AboutHeroLayout(
  props: React.HTMLAttributes<HTMLDivElement> & HeroLayoutProps,
) {
  const { alignLeft, children } = props;

  return (
    <HeroLayoutRoot>
      {/* Image Background */}
      <ImageBackground src="/images/about-hero.jpg" alt="Background" />

      <Container
        sx={{
          mt: 3,
          mb: 14,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center', // Center vertically
          height: '100%', // Take full height for vertical centering
        }}
      >
        {alignLeft && (
          <Box
            sx={{
              position: 'absolute',
              left: { xs: 20, sm: 100 }, // Responsive left positioning
              top: { xs: 30, sm: 50 }, // Responsive top positioning
              zIndex: 2,
              width: { xs: 'calc(100% - 40px)', sm: 750 }, // Responsive width
            }}
          >
            {children}
          </Box>
        )}
        {!alignLeft && children}
      </Container>
    </HeroLayoutRoot>
  );
}